import { render, staticRenderFns } from "./canvasGenerate.vue?vue&type=template&id=0b4265f6&scoped=true"
import script from "./canvasGenerate.vue?vue&type=script&lang=js"
export * from "./canvasGenerate.vue?vue&type=script&lang=js"
import style0 from "./canvasGenerate.vue?vue&type=style&index=0&id=0b4265f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4265f6",
  null
  
)

export default component.exports